<template>
    <b-card
        class="property-saved-searches-card mt-2 clickable-container"
        body-class="snap-panel-wrapper p-0"
        @click="handleCardClick"
    >
        <b-button
            class="mobile-cell property-saved-search-edit"
            @click.stop="openPropertySavedSearchesEditModal"
        >
          Edit
        </b-button>

        <b-row class="mobile-cell no-gutters px-3 py-3 pt-sm-4 pb-sm-2 px-sm-0 middle-content">
            <property-saved-searches-card-header
                :property-search-filter-app-resource="propertySearchFilterAppResource"
                class="col-12 px-4 mb-sm-0"
            />
            <property-saved-searches-card-content
                :property-search-filter-app-resource="propertySearchFilterAppResource"
                class="col-12 px-4"
            />
            <b-col
                class="px-4"
                v-if="!isMobile"
            >
                <b-button
                    variant="transparent"
                    class="text-primary px-0 run-search-button"
                    @click.stop="displaySavedSearch"
                    size="lg"
                >
                    Run Search
                </b-button>
            </b-col>
            <property-saved-searches-card-footer
                v-if="!isMobile"
                :property-search-filter-app-resource="propertySearchFilterAppResource"
                class="col-12 px-4 pt-2"
            />
        </b-row>

        <b-button
            class="mobile-cell property-saved-search-delete rounded-0"
            @click.stop="deleteSavedSearch"
        >
          Delete
        </b-button>
    </b-card>
</template>

<script>
    import './PropertySavedSearchesCard.scss';
    import {proxyFilter} from "../../../classes/Filter";
    import PropertySearchFilterAppResource
        from "@milestoneslabs/milestones-core-js/src/AppResources/PropertySearchFilterAppResource";
    import IsMobileMixin, {VIEW_BREAKPOINTS} from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";
    import {PROPERTY_SAVED_SEARCHES_EDIT_MODAL_DISPLAY}
        from "./PropertySavedSearchesEditModal/PropertySavedSearchesEditModal";
    import {DELETE_SAVED_SEARCH_MODAL_DISPLAY}
        from "./../DeleteSavedSearchModal/DeleteSavedSearchModal";
    import ShowNotificationMixin
        from '@milestoneslabs/milestones-ui-kit/src/mixins/ShowNotificationMixin';

    import PropertySavedSearchesCardContent
        from "./PropertySavedSearchesCardContent/PropertySavedSearchesCardContent";
    import PropertySavedSearchesCardFooter
        from "./PropertySavedSearchesCardFooter/PropertySavedSearchesCardFooter";

    export const PROPERTY_SAVED_SEARCH_DISPLAY = 'PropertySavedSearch:display';
    export const PROPERTY_SAVED_SEARCH_INSTANCE_MOUNTED = 'PropertySavedSearch:instance_mounted';

    export default {
        name: "PropertySavedSearchesCard",
        components: {
            PropertySavedSearchesCardHeader: () => {
                return import("./PropertySavedSearchesCardHeader/PropertySavedSearchesCardHeader");
            },
            PropertySavedSearchesCardContent,
            PropertySavedSearchesCardFooter,
        },

        mixins: [IsMobileMixin, ShowNotificationMixin],

        props: {
            propertySearchFilterAppResource: {
                type: PropertySearchFilterAppResource,
                required: true,
            }
        },

        data() {
            return {
                filter: proxyFilter,
            };
        },

        computed: {
            snapCard() {
                return this.$el.getElementsByClassName('snap-panel-wrapper')[0];
            },
        },

        created() {
            window.addEventListener('resize', this.onWindowResize);
        },

        beforeMount() {
            this.$bus.$on(PROPERTY_SAVED_SEARCH_INSTANCE_MOUNTED, this.animateScrollCard);
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.onWindowResize);
            this.$bus.$off(PROPERTY_SAVED_SEARCH_INSTANCE_MOUNTED, this.animateScrollCard);
        },

        mounted() {
            this.$nextTick(function () {
                this.animateScrollCard();
            });
        },

        methods: {
            handleCardClick() {
                if (this.isMobile) {
                    this.displaySavedSearch();
                }
            },

            displaySavedSearch() {
                this.$bus.$emit(PROPERTY_SAVED_SEARCH_DISPLAY, this.propertySearchFilterAppResource);
            },

            openPropertySavedSearchesEditModal() {
                this.$bus.$emit(PROPERTY_SAVED_SEARCHES_EDIT_MODAL_DISPLAY, {
                    entity: this.propertySearchFilterAppResource
                });
            },

            async deleteSavedSearch() {
                this.$bus.$emit(DELETE_SAVED_SEARCH_MODAL_DISPLAY, {
                    entity: this.propertySearchFilterAppResource
                });
            },

            async scrollToAndCall(container, posTop = 0, posLeft = 0, behavior = 'smooth') {
                posTop = Math.round(posTop);
                posLeft = Math.round(posLeft);

                let resolveFn, scrollListener, timeoutId;

                const promise = new Promise(resolve => {
                    resolveFn = resolve;
                });

                const finished = () => {
                    container.removeEventListener('scroll', scrollListener);
                    resolveFn();
                };

                if (container.scrollTop === posTop && container.scrollLeft === posLeft) {
                    setTimeout(finished, 100);
                } else {
                    scrollListener = () => {
                        clearTimeout(timeoutId);

                        // scroll is finished when either the position has been reached,
                        // or 100ms have elapsed since the last scroll event
                        if (container.scrollTop === posTop && container.scrollLeft === posLeft) {
                            finished();
                        } else {
                            timeoutId = setTimeout(finished, 100);
                        }
                    };

                    container.addEventListener('scroll', scrollListener);

                    container.scrollTo({
                        top: posTop,
                        left: posLeft,
                        behavior: behavior
                    });
                }

                return promise;
            },

            animateScrollCard() {

                if (!this.snapCard || !this.isMobile) {
                    return;
                }
                var el = this.snapCard,
                    maxFullAnimation = 5,
                    multiplyDelay = Math.abs([...el.parentNode.parentNode.children].indexOf(el.parentNode)),
                    that = this;

                if (multiplyDelay > maxFullAnimation-1) {
                    that.scrollToAndCall(el, 0, 83, 'auto');
                } else {
                    setTimeout(() => {
                        that
                            .scrollToAndCall(el, 0, 130, 'smooth')
                            .then(() => {
                                that
                                    .scrollToAndCall(el, 0, 83, 'smooth');
                            })
                        ;
                    }, multiplyDelay * 70);
                }
            },

            onWindowResize() {
                if(!!window.resizedFinished) {
                    clearTimeout(window.resizedFinished);
                }
                var that = this;
                window.resizedFinished = setTimeout(function() {
                    that.$nextTick(function () {
                        that.$bus.$emit(PROPERTY_SAVED_SEARCH_INSTANCE_MOUNTED);
                    });
                }, 500);
            }
        },
    };
</script>
